const MissingHeader = ({ className = "" }: { className?: string }) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 p-6 ${className}`}
    >
      <div className="text-center py-12">
        <div className="text-gray-500">
          <div className="text-6xl mb-4">⚠️</div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Strategy data not available
          </h3>
          <p className="text-gray-600">
            Unable to load strategy information. Please try again.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MissingHeader;
